'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugify = slugify;
function slugify(str) {
  var string = str.replace(/^\s+|\s+$/g, ''); // trim
  string = string.toLowerCase();

  var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;\'';
  var to = 'aaaaeeeeiiiioooouuuunc-------';

  for (var index = 0, length = from.length; index < length; index++) {
    string = string.replace(new RegExp(from.charAt(index), 'g'), to.charAt(index));
  }

  string = string.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
  .replace(/\s+/g, '-') // collapse whitespace and replace by -
  .replace(/-+/g, '-') // collapse dashes
  .replace(/^[\-]+|[\-]+$/g, '');

  return string;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/strings.js
// module id = 303
// module chunks = 0